import { useState } from "react";

const MOTION_KEY = "todoit-animations";

// An explicit choice made in the app wins; otherwise follow the OS-level
// "prefers reduced motion" setting. Any future animation should check this.
export const animationsEnabled = (): boolean => {
  try {
    const stored = window.localStorage.getItem(MOTION_KEY);
    if (stored === "on") return true;
    if (stored === "off") return false;
  } catch {}
  return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

export const MotionControl = () => {
  const [enabled, setEnabled] = useState(animationsEnabled);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    try {
      window.localStorage.setItem(MOTION_KEY, next ? "on" : "off");
    } catch {}
  };

  return (
    <button
      onClick={toggle}
      role="switch"
      aria-checked={enabled}
      aria-label="Animations"
      title={enabled ? "Animations on" : "Animations off"}
      className={`min-h-10 sm:min-h-0 px-2 py-1 rounded text-xs ${
        enabled ? "bg-neutral-100 text-neutral-700" : "bg-neutral-100 text-neutral-400 line-through"
      }`}
    >
      Motion
    </button>
  );
};
